module.exports = __webpack_public_path__ + "2021120:beba53acebe35c990492/img/hero-sq@1x.51495ed.jpg";